import { AfaRadio } from '../AfaRadio';
import classes from './AfaEntitatCard.module.css';

export interface AfaEntitatCardProps {
  /** Nombre de la entidad */
  entityName: string;
  
  /** Lista de nombres de filiales */
  filials?: string[];
  
  /** Si está seleccionada */
  checked: boolean;
  
  /** Callback al hacer clic */
  onClick: () => void;
  
  /** Valor único para el radio button */
  value: string;
}

/**
 * Componente de tarjeta para seleccionar una entidad con sus filiales
 * 
 * Ejemplo de uso:
 * 
 * ```tsx
 * <AfaEntitatCard
 *   entityName="Nom de l'Entitat 1"
 *   filials={["Nom de la filial 1", "Nom de la filial 2", "Nom de la filial 3"]}
 *   checked={selectedEntity === 'entity1'}
 *   onClick={() => setSelectedEntity('entity1')}
 *   value="entity1"
 * />
 * ```
 */
export function AfaEntitatCard({
  entityName,
  // filials,
  checked,
  onClick,
  value
}: AfaEntitatCardProps) {
  return (
    <div
      className={`${classes.card} ${checked ? classes.selected : ''}`}
      onClick={onClick}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onClick();
        }
      }}
    >
      <AfaRadio
        checked={checked}
        onChange={onClick}
        value={value}
      />
      <div className={classes.content}>
        <div className={classes.entityName}>{entityName}</div>
        {/* <div className={classes.filials}>
          {filials.map((filial, index) => (
            <div key={index}>{filial}</div>
          ))}
        </div> */}
      </div>
    </div>
  );
}
